export default {"src":"/_next/static/image/public/images/ic_mypackage.64a6059e45e47558a666d70de8486800.svg","height":15,"width":18};